module.exports = __webpack_public_path__ + "static/media/blog_grid_8.8371ea7b.jpg";